import { useContext } from 'react'
import { FrameContext } from '../components/MobileDetection'

export function useFrame() {
  return useContext(FrameContext)
}
